import React from 'react';
import {Link} from "react-scroll";
//Image... 
import HeaderImg from '../images/HeaderImg.png'

export const Hero = () => {
    return (
        <main>
            <section className='hero-section' id='hero' style={{backgroundImage: `url(${HeaderImg})`}}>
                <div className='hero-overlay'>
                    <div className='section-content'>
                        <div className='hero-details'>
                            <h1 className='title'>
                                Healing Your Body, Mind & Spirit
                            </h1>

                            <p className='description'>
                                Your well-being is at the heart of everything I do. At Saisha Spiritual Touch, I create personalized healing experiences that help you relax, restore balance, and reconnect with yourself in a peaceful and nurturing environment.
                            </p>
                            <p className='description'>
                                Whether you're looking for therapeutic massage, Reiki, sound healing, prenatal care, or holistic wellness services, each session is customized to support your individual journey toward better health and wellness.
                            </p>
                            
                            <div className='buttons'>
                                <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-90} duration={500} className='button primary-button'>
                                    Book a Session
                                </Link>
                                <Link activeClass='active' to='services' spy={true} smooth={true} offset={-90} duration={500} className='button secondary-button'>
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}